import React, { useEffect, useState } from 'react';
import { ContentFooter, ContentWrapper, ContentWrapperInner } from "../../layout/Wrapper";
import ContentFooterLink from "../../interactive/ContentFooterLink";
import CoreLandingPage from "../landing_pages/CoreLandingPage";
import CoreCISLandingPage from "../landing_pages/CoreCISLandingPage";
import NextYearClaimLandingPage from "../landing_pages/NextYearClaimLandingPage";
import SoleTraderLandingPage from "../landing_pages/SoleTraderLandingPage";
import { updatePageTitle } from "../../../modules/legacyUtils";
import { fetch } from "../../../modules/utils";
import { trackEvent } from "../../../modules/tracking";
import { AnalyticsEvents } from "../../../modules/analyticsEvents";
export default function PostAuthorisationIndex({ isCIS }) { const [isLoading, setIsLoading] = useState(true); const [isNextYearClaim, setIsNextYearClaim] = useState(false); const [isSoleTrader, setIsSoleTrader] = useState(false); useEffect(() => { updatePageTitle('Thank you'); trackEvent(AnalyticsEvents.forms.submittedPostAuthorisation()); fetch('GET', '/landing_pages.json', 'application/json', 'application/json').then(data => { const { isNextYearClaim, isSoleTrader } = data; setIsNextYearClaim(isNextYearClaim); setIsSoleTrader(isSoleTrader); setIsLoading(false); if (isNextYearClaim) {
    trackEvent(AnalyticsEvents.screenViews.postAuthorisation('Next Year Claim'));
}
else if (isSoleTrader) {
    trackEvent(AnalyticsEvents.screenViews.postAuthorisation('Sole Trader'));
}
else if (isCIS) {
    trackEvent(AnalyticsEvents.screenViews.postAuthorisation('Post Submission'));
}
else {
    trackEvent(AnalyticsEvents.screenViews.postAuthorisation('Core'));
} }).catch(() => { setIsLoading(false); }); }, [isCIS]); const renderBody = () => { if (isLoading) {
    return /*#__PURE__*/ React.createElement("p", null, "Loading...");
}
else if (isNextYearClaim) {
    return /*#__PURE__*/ React.createElement(NextYearClaimLandingPage, null);
}
else if (isSoleTrader) {
    return /*#__PURE__*/ React.createElement(SoleTraderLandingPage, null);
}
else if (isCIS) {
    return /*#__PURE__*/ React.createElement(CoreCISLandingPage, null);
} return /*#__PURE__*/ React.createElement(CoreLandingPage, null); }; return /*#__PURE__*/ React.createElement(ContentWrapper, { modifiers: "small" }, /*#__PURE__*/ React.createElement(ContentWrapperInner, { modifiers: "longform" }, renderBody()), /*#__PURE__*/ React.createElement(ContentFooter, null, /*#__PURE__*/ React.createElement(ContentFooterLink, { to: "/my_rift/dashboard", backLink: true }, "Back to Home"))); }
